<template>
    <div>
        <div class="container container-mob" >
            <p style="color: black; text-align: left; font-size: 2em; font-weight:bold">
                <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>
                {{$t('message.contacts')}}</p>
        </div>
        <div class="container" >
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">{{$t('message.main_page')}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t('message.contact_us')}}</li>
                </ol>
            </nav>
            <hr>

            <div class="block2-main center-block-main">
                <article>
                    <h6 style="font-size: 18px"><strong>{{$t('message.phone')}}:</strong></h6>
                    <p>+998 71 241 01 86</p>
                </article>
                <article>
                    <h6 style="font-size: 18px"><strong>{{$t('message.email')}}:</strong></h6>
                    <p>info@ppp.uz</p>
                </article>
                <article>
                    <h6 style="font-size: 18px"><strong>{{$t('message.address')}}:</strong></h6>
                    <p>{{$t('message.full_address')}}</p>
                </article>
                <article>
                    <h6 style="font-size: 18px"><strong>{{$t('message.website')}}:</strong></h6>
                    <p>http://ppp.uzedu.uz</p>
                </article>
            </div>

            <div class="content_area">
                <div class="text-center">
                    <div id="lipsum">
                        <h6>
                            <strong>
                                <span style="font-size:18px; text-align: center">{{$t('message.working_time')}}</span>
                            </strong>
                        </h6>

                        <div class="contacts-schedule">
                            <div class="contacts-schedule__inner">
                                <div class="contacts-schedule__item">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.monday')}}</span></div>
                                    <div class="contacts-schedule__item-time">09:00<span> - </span>18:00</div>
                                </div>

                                <div class="contacts-schedule__item">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.tuesday')}}</span></div>
                                    <div class="contacts-schedule__item-time">09:00<span> - </span>18:00</div>
                                </div>

                                <div class="contacts-schedule__item">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.wednesday')}}</span></div>
                                    <div class="contacts-schedule__item-time">09:00<span> - </span>18:00</div>
                                </div>

                                <div class="contacts-schedule__item">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.thursday')}}</span></div>
                                    <div class="contacts-schedule__item-time">09:00<span> - </span>18:00</div>
                                </div>

                                <div class="contacts-schedule__item">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.friday')}}</span></div>
                                    <div class="contacts-schedule__item-time">09:00<span> - </span>18:00</div>
                                </div>

                                <div class="contacts-schedule__item contacts-schedule__item--disabled">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.saturday')}}</span></div>
                                    <div class="contacts-schedule__item-time">-</div>
                                </div>

                                <div class="contacts-schedule__item contacts-schedule__item--disabled">
                                    <div class="contacts-schedule__item-day"><span>{{$t('message.sunday')}}</span></div>
                                    <div class="contacts-schedule__item-time">-</div>
                                </div>

                            </div>
                        </div>
                        <iframe src="https://yandex.uz/map-widget/v1/-/CCUFAHgo~A" width="100%" height="294" frameborder="0"></iframe>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
 export default {
     name: 'contact-us'
 }
</script>

<style>
/*    .navbar-nav .nav-item, .bsnav .nav-link {
        color: black !important;
    }*/

    .contacts-schedule__item {
        min-width: 75px;
        margin: 17px 11px;
        float: left;
    }

    .contacts-schedule__item-day {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        border: solid;
        margin: 0 auto 20px;
    }

    .contacts-schedule__item-time {
        font-size: .75rem;
        text-align: center;

    }

    .center-block-main {
        max-width: 100%;
        margin: 0 auto;
        padding-top: 10px;
    }

    .block2-main {
        padding-top: 50px;
        padding-bottom: 230px;
        cursor: default;
    }

    .block2-main article {
        width: 35%;
        float: left;
        margin-right: 15%;
    }
    .container-mob {
        padding-top: 100px;
        display: flex;
    }
</style>
